<template>
  <!-- Root Vuetify App -->
  <v-app>
    <!-- Use BaseLayout to encapsulate drawer + app-bar + main -->
    <BaseLayout
      v-model:drawer="drawer"
      :mobile="display.smAndDown.value"
    >
      <template #default>
        <router-view v-slot="{ Component, route }">
          <component
            :is="Component"
            :key="route.fullPath"
          />
        </router-view>
      </template>
    </BaseLayout>

    <!-- Overlay orchestrator (modals, pickers, etc.) -->
    <OverlayOrchestrator />
  </v-app>
</template>

<script setup>
import { ref } from 'vue';
import { useDisplay } from 'vuetify';
import BaseLayout from '@/presentation/components/layout/BaseLayout.vue';
import OverlayOrchestrator from '@/presentation/components/overlay/OverlayOrchestrator.vue';

// Reactive drawer state
const drawer = ref(true);
// Vuetify display breakpoints
const display = useDisplay();
</script>
